import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { link } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  items[] {
    "id": id.current,
    title,
    subtitle,
    description[]{${richTextFields}},
    featureList[],
    ${link.fragment('cta')}
  }
`

export const fragment = (name = 'serviceBlocks') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
